import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState } from '../../../common/state';
import { ICollectionItem } from '../../../offer';
import { Slider } from '../Slider';
import * as styles from './Collections.css';
import { Collection } from './components/Collection';
import { trackClickCollection, trackSwipeCollection } from './tracking';

const SLIDER_CLASSES = {
  group: styles['slider-group'],
  groupsContainer: styles['slider-groups-container'],
};

interface IProps {
  collectionItems: ICollectionItem[];
  cdnBaseUrl: string;
}

export const CollectionsComponent = ({ collectionItems, cdnBaseUrl }: IProps) => {
  const createClickHandler = (queryString: string) => () => {
    trackClickCollection(queryString);
  };

  if (collectionItems.length === 0) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <Slider
        visibleSlidesCount={4}
        step={4}
        classes={SLIDER_CLASSES}
        onPrevButtonClick={trackSwipeCollection}
        onNextButtonClick={trackSwipeCollection}
      >
        {collectionItems.map(({ key, title, url, label, queryString, textColor, backgroundColor }) => (
          <Collection
            key={title}
            cdnBaseUrl={cdnBaseUrl}
            className={styles['desktop-card']}
            href={url}
            title={title}
            imageKey={key}
            label={label}
            color={textColor}
            backgroundColor={backgroundColor}
            onClick={createClickHandler(queryString)}
          />
        ))}
      </Slider>
    </div>
  );
};

export const mapStateToProps = (state: IAppState): IProps => {
  return {
    collectionItems: state.collections || [],
    cdnBaseUrl: state.config.get<string>('collectionsCdn.baseUrl') || '//cdn.cian.site/frontend/collections-assets/',
  };
};

export const Collections = connect(mapStateToProps)(React.memo(CollectionsComponent));
